<template>
  <div class="w-full height-100 bg-white">
    <el-dialog title="" :visible.sync="AddProductPopup" width="35%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Add Product
        </h3></template
      >
      <AddProduct
        @closePopup="closeAddProduct"
        :AddProductPopup="AddProductPopup"
      />
    </el-dialog>
    <el-dialog title="" :visible.sync="EditProductPopup" width="35%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Edit Product
        </h3></template
      >
      <EditProduct
        @closePopup="closeEditProduct"
        :editProduct="selectedEditProduct"
        :EditProductPopup="EditProductPopup"
      />
    </el-dialog>
    <el-dialog title="" :visible.sync="insertMetaPopup" width="35%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Meta Tag
        </h3></template
      >
      <InsertMeta
        @closePopup="closeInsertMeta"
        :insertMeta="selectedInsertMeta"
        :insertMetaPopup="insertMetaPopup"
      />
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="isShowManageOrder"
      :before-close="handleProductDetailsClose"
    >
      <template slot="title"
        ><h3 class="fsize18 Add mb-0 Products text-white">
          Product Details
        </h3></template
      >
      <div>
        <CartProductTable />
      </div>
    </el-dialog>
    <!-- add variation -->
    <el-dialog title="" :visible.sync="AddAttribuitesShow" width="30%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Add Variation
        </h3></template
      >
      <AddAttribuites
        :productDetail="productDetail"
        :AddAttribuitesShow="AddAttribuitesShow"
        @closePopup="closeVariationPopup"
      />
    </el-dialog>
    <!-- Edit variation -->
    <el-dialog title="" :visible.sync="EditAttribuitesShow" width="30%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Edit Variation
        </h3></template
      >
      <EditAttribuites
        :productDetail="productDetail"
        :EditAttribuitesShow="EditAttribuitesShow"
        @closePopup="closeEditVariationPopup"
      />
    </el-dialog>

    <!-- add Attribute -->
    <el-dialog title="" :visible.sync="AddAttributesPopup" width="40%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Add Attribute
        </h3></template
      >
      <AddVariationPopup
        @closePopup="attributePopupOpen"
        @closePopupMain="closePopupMains"
        :productDetail="productDetail"
      />
    </el-dialog>

    <!-- edit Attribute -->
    <el-dialog
      title=""
      :visible.sync="EditAttribuitesValShow"
      width="40%"
      center
    >
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Edit Attribute
        </h3></template
      >
      <EditAttribuitesVal
        @closePopup="closeEditAttributeValPopup"
        :attrName="attrName"
        :EditAttribuitesValShow="EditAttribuitesValShow"
        :productDetail="productDetail"
      />
    </el-dialog>

    <el-dialog
      title=""
      class="parentto-child-zindex"
      :visible.sync="AddColor"
      width="30%"
      center
      :before-close="handelClose"
    >
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Add Color
        </h3></template
      >
      <AddAttribuitesVal @closePopup="attributeValPopupOpen" />
    </el-dialog>

    <el-dialog title="" :visible.sync="centerDialogVisiblec" width="30%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Add Color Variant
        </h3></template
      >
      <Color />
    </el-dialog>
    <el-dialog title="" :visible.sync="centerDialogVisibles" width="30%" center>
      <template slot="title"
        ><h3 class="text-xl Add mb-0 Products text-left text-white">
          Add Size
        </h3></template
      >
      <Size />
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Add Products
          </h2>
        </div>
      </div>
    </div>
    <div class="fixed-top bg-white p-6">
      <div class="w-full flex justify-between items-center w-full mb-6 gap-2">
        <el-input
          v-model="search"
          placeholder="Search here..."
          maxlength="50"
          class="w-10/12"
        />
        <vs-button
          @click="AddProductPopup = true"
          type="primary"
          class="bg-primary rounded-lg font-medium py-4"
          >Add Product</vs-button
        >
      </div>
      <div class="" v-if="productDetails && productDetails.length > 0">
        <div
          class="border rounded-10px bg-white p-4 mb-4"
          v-for="(item, pindex) in productDetails"
          :key="`${item} + ${pindex}`"
        >
          <div class="flex">
            <div class="w-1/4 flex items-center bg-f4f5f6">
              <img
                :src="
                  item.productImageId &&
                  item.productImageId.length > 0 &&
                  item.productImageId[0].productImage &&
                  item.productImageId[0].productImage.length > 0 &&
                  item.productImageId[0].productImage[0]
                    ? attachImg(item, pindex)
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/ecom.svg'
                "
                class="object-contain bg-f9 w-full heighjk"
                alt="banh"
              />
            </div>
            <div class="w-3/4 pl-6">
              <div
                class="w-full flex bg-white justify-between items-center rounded-lg"
              >
                <h3 class="fsize20 mb-0 text-black font-semibold">
                  {{ item.productName }}
                </h3>

                <div class="flex items-center gap-4">
                  <feather-icon
                    icon="TagIcon"
                    class="cursor-pointer"
                    svgClasses="w-5 h-5"
                    @click="insertMeta(true, item)"
                  />
                  <feather-icon
                    icon="Edit2Icon"
                    class="cursor-pointer"
                    svgClasses="w-5 h-5"
                    @click="editProduct(true, item)"
                  />
                  <!-- <feather-icon
                    icon="EyeIcon"
                    class="cursor-pointer"
                    svgClasses="w-5 h-5"
                  /> -->
                  <feather-icon
                    icon="TrashIcon"
                    class="cursor-pointer"
                    svgClasses="w-5 h-5"
                    @click="deletePopup(item)"
                  />

                  <!-- <el-popover
                    content="Manage SKU"
                    placement="top-start"
                    width="150"
                    trigger="hover"
                  >
                    <feather-icon
                      @click="isShowManageOrder = true"
                      slot="reference"
                      icon="ShoppingCartIcon"
                      class="cursor-pointer"
                      svgClasses="w-5 h-5"
                    />
                  </el-popover> -->

                  <vs-button
                    type="primary"
                    @click="handlePublish(item)"
                    class="bg-light-primary text-primary font-semibold"
                    >{{ item.isPublished ? "Unpublish" : "Publish" }}</vs-button
                  >
                </div>
              </div>
              <div class="mt-2">
                <div class="flex gap-4 items-center">
                  <div>
                    <p
                      class="font-semibold flex gap-1 text-525252 my-0 fsize14"
                    >
                      Category-<span class="font-medium text-8f8f8f"> </span>
                      <el-tag
                        class="light-purplebgtext border-none skutag"
                        v-for="(category, index) in item.categoryName"
                        :key="`${category} + ${index}`"
                        >{{ category.categoryName }}</el-tag
                      >
                    </p>
                  </div>
                  <div>
                    <p
                      class="font-semibold flex gap-1 text-525252 my-0 fsize14"
                    >
                      Sub Category-<span class="font-medium text-8f8f8f"></span>
                      <el-tag
                        class="light-purplebgtext border-none skutag"
                        v-for="(subCat, index) in item.subcatName"
                        :key="`${subCat} + ${index}`"
                        >{{ subCat.categoryName }}</el-tag
                      >
                    </p>
                  </div>
                </div>

                <p class="font-medium text-8f8f8f my-3 fsize14">
                  {{ item.description }}
                </p>
              </div>

              <div class="mt-4 grid grid-cols-2 gap-4">
                <div class="p-3 bg-f8 rounded-lg">
                  <div class="flex justify-between w-full">
                    <div>
                      <h3 class="text-lg mb-0 col-headsf font-semibold">
                        {{ item.attributesId[0].name }}
                      </h3>
                    </div>
                    <div class="flex gap-3 items-center">
                      <feather-icon
                        @click="addAttributes(item)"
                        icon="PlusIcon"
                        class="cursor-pointer"
                        svgClasses="w-5 h-5"
                      />
                      <!-- <feather-icon
                        icon="EyeIcon"
                        class="cursor-pointer"
                        svgClasses="w-5 h-5"
                      /> -->
                    </div>
                  </div>
                  <div class="pnamechips-scroll">
                    <div class="flex gap-3 mt-3">
                      <el-tag
                        v-for="(att, index) in item.productImageId"
                        :key="`${att} + ${index}`"
                        @click="editAttributesVal(item, att)"
                        class="rounded-full cursor-pointer bg-lightprimary-chips font-semibold"
                      >
                        <div
                          @mouseover="prodImg(item, att, pindex)"
                          @mouseout="resetImg"
                        >
                          {{ att.valueName }}
                        </div>
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="p-3 bg-f8 rounded-lg">
                  <div class="flex justify-between w-full">
                    <div>
                      <h3 class="text-lg mb-0 col-headsf font-semibold">
                        {{ item.attributesId[1].name }}
                      </h3>
                    </div>
                    <div class="flex gap-3 items-center">
                      <!-- <feather-icon
                        @click="AddAttribuitesShow = true"
                        icon="EyeIcon"
                        class="cursor-pointer"
                        svgClasses="w-5 h-5"
                      /> -->
                      <feather-icon
                        v-if="item.productImageId"
                        @click="addVariation(item)"
                        icon="PlusIcon"
                        class="cursor-pointer"
                        svgClasses="w-5 h-5"
                      />
                    </div>
                  </div>
                  <div class="pnamechips-scroll">
                    <div class="flex gap-3 mt-3">
                      <el-tag
                        v-for="(att, index) in item.variationId"
                        :key="`${att} + ${index}`"
                        @click="editVariation(att)"
                        class="rounded-full cursor-pointer bg-lightprimary-chips font-semibold"
                      >
                        {{ att.variationValueName }}
                      </el-tag>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center">
        <h1>No Products</h1>
      </div>
      <div class="w-full flex justify-end mt-6" v-if="totalRowsState > 0">
        <el-pagination
          background
          layout="prev,pager,next"
          :total="totalRowsState"
          :page-size="perPageState"
          @current-change="setPage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
import Color from "../components/popup/Color.vue";
import CartProductTable from "./CartProductTable.vue";
import Size from "../components/popup/Size.vue";
import AddProduct from "./myproduct/AddProduct.vue";
import AddVariationPopup from "./myproduct/AddVariationPopup.vue";
import AddAttribuites from "./myproduct/AddAttribuites.vue";
import EditAttribuites from "./myproduct/EditAttribuites.vue";
import EditAttribuitesVal from "./myproduct/EditAttributeVal.vue";
import AddAttribuitesVal from "./myproduct/addAttributeVal.vue";
import EditProduct from "./myproduct/EditProduct.vue";
import InsertMeta from "./myproduct/InsertMeta.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      centerDialogVisiblec: false,
      centerDialogVisibles: false,
      AddProductPopup: false,
      EditProductPopup: false,
      insertMetaPopup: false,
      selectedInsertMeta: {},
      AddAttributesPopup: false,
      AddVariationPopup: false,
      AddAttribuitesShow: false,
      EditAttribuitesShow: false,
      EditAttribuitesValShow: false,
      AddAttribuitesValShow: false,
      AddColor: false,
      productDetail: {},
      isShowManageOrder: false,
      selectedEditProduct: {},
      attrName: {},
      hoverImg: "",
      hoverIndex: null,

      search: this.searchState || "",
      // totalRows: this.totalRowsState || 0,
      // perPage: this.perPageState || 10,
      currentPage: this.currentPageState || 1,
    };
  },
  components: {
    Color,
    Size,
    AddProduct,
    EditProduct,
    InsertMeta,
    AddVariationPopup,
    AddAttribuites,
    AddAttribuitesVal,
    CartProductTable,
    EditAttribuites,
    EditAttribuitesVal,
  },
  watch: {
    async currentPage() {
      await this.getProduct();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getProduct();
      }, 500),
    },
  },
  methods: {
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    attachImg(item, pindex) {
      if (pindex === this.hoverIndex) {
        return this.hoverImg;
      } else {
        return this.getImage(item.productImageId[0].productImage[0]);
      }
    },
    resetImg() {
      this.hoverIndex = null;
      this.hoverImg = "";
    },
    prodImg(item, imgArr, pindex) {
      this.hoverIndex = pindex;
      this.hoverImg =
        imgArr.productImage && imgArr.productImage.length > 0
          ? this.getImage(imgArr.productImage[0])
          : "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/ecom.svg";
      // console.log(this.hoverIndex, this.hoverImg);
    },
    async UnPublishPopup() {
      await this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Yes, Unpublish it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        // if (result.value) {
        // this.$swal("Deleted", "Successfully deleted", "success");
        // this.handlePublish(publishData);
        return result.value;
        // }
      });
    },
    async handlePublish(item) {
      let publishData = !item.isPublished;
      if (publishData === false) {
        let isUnpublishConfirm = await this.UnPublishPopup();
        if (isUnpublishConfirm === false) {
          return;
        }
      }
      const payload = {
        isPublished: publishData,
        productId: item._id,
      };
      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let data = await this.$store.dispatch(
          "EcomProduct/editProduct",
          payload
        );
        if (data.code === 200) {
          // await this.$store.dispatch("EcomProduct/getProduct");
          await this.getProduct();
          loader.close();
          await this.$swal({
            title: `Product ${publishData ? "Published" : "Unpublished"}!`,
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
        loader.close();
      } catch (error) {
        loader.close();

        await this.$swal({
          title: `Failed to update the product!`,
          type: "error",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#cd3197",
        });
      }
    },
    async deletePopup(row) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        confirmButtonColor: "#cd3197",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.handleDelete(row._id);
        }
      });
    },
    async handleDelete(productId) {
      let payload = {
        productId: productId,
        // adminId: this.login._id,
      };
      try {
        let data = await this.$store.dispatch(
          "EcomProduct/deleteProduct",
          payload
        );
        if (data.code === 200) {
          // await this.$store.dispatch("EcomProduct/getProduct");
          await this.getProduct();
          await this.$swal("Deleted", "Successfully deleted", "success");
        }
      } catch (error) {
        await this.$swal("Delete", "Failed to Delete", "error");
      }

      //   this.currentPage = 1;
    },
    editProduct(active, data = null) {
      this.EditProductPopup = true;
      this.selectedEditProduct = data;
    },
    insertMeta(active, data = null) {
      this.insertMetaPopup = true;
      this.selectedInsertMeta = data;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    attributePopupOpen() {
      this.AddAttributesPopup = false;
      this.AddColor = true;
    },
    closeVariationPopup() {
      this.AddAttribuitesShow = false;
    },
    closeEditVariationPopup() {
      this.EditAttribuitesShow = false;
    },
    closeEditAttributeValPopup() {
      this.EditAttribuitesValShow = false;
    },
    closePopupMains() {
      this.AddAttributesPopup = false;
    },
    handelClose() {
      this.AddAttributesPopup = true;
      this.AddColor = false;
    },
    handleProductDetailsClose() {
      this.isShowManageOrder = false;
    },
    attributeValPopupOpen() {
      this.AddAttributesPopup = true;
      this.AddColor = false;
    },
    addAttributes(data) {
      this.productDetail = data;
      this.AddAttributesPopup = true;
      // this.$store.state.EcomAttributes.onClickProduct = data;
      this.$store.commit("EcomAttributes/SET_ON_CLICK_PRODUCT", data);
    },
    closeAddProduct() {
      this.AddProductPopup = false;
    },
    closeEditProduct() {
      this.EditProductPopup = false;
    },
    closeInsertMeta() {
      this.insertMetaPopup = false;
    },
    async getProduct() {
      this.$store.commit("EcomProduct/SET_CURRENTPAGESTATE", this.currentPage);
      this.$store.commit("EcomProduct/SET_SEARCHSTATE", this.search);
      // let curPage = this.currentPage - 1;
      // let payload = {
      //   limit: this.perPage,
      //   offset: curPage,
      // };
      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // if (this.search !== "") {
        //   Object.assign(payload, { search: this.search.trim() });
        // }
        let data = await this.$store.dispatch("EcomProduct/getAllProduct");
        if (data.code === 200) {
          loader.close();
          // this.totalRows = data.data.totalCount;
          // this.$store.commit("EcomProduct/SET_TOTALROWSSTATE", this.totalRows);
        }
        loader.close();
      } catch (error) {
        loader.close();
        await this.$swal({
          title: `Failed to Fetch the Products!`,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#cd3197",
        });
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.$store.commit("EcomProduct/SET_CURRENTPAGESTATE", page);
    },
    async loadData() {
      await this.$store.dispatch("tags/getTags");
      await this.$store.dispatch("EcomAttributes/getAttributes");
      await this.$store.dispatch("EcomCategory/getDetailedCategory");
    },
    addVariation(data) {
      this.AddAttribuitesShow = true;
      // this.$store.state.EcomAttributes.onClickProduct = data;
      this.$store.commit("EcomAttributes/SET_ON_CLICK_PRODUCT", data);
      this.productDetail = data;
    },
    editVariation(data) {
      this.productDetail = data;
      this.EditAttribuitesShow = true;
    },
    editAttributesVal(data, attr) {
      this.attrName = data;
      this.productDetail = attr;
      this.EditAttribuitesValShow = true;
    },
  },
  mounted() {
    this.getProduct();
    this.loadData();
  },
  computed: {
    ...mapState("EcomProduct", [
      "productDetails",
      "allProductDetails",
      "perPageState",
      "currentPageState",
      "searchState",
      "totalRowsState",
    ]),
  },
};
</script>
